var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.app !== undefined && _vm.app.termsVisible)?_c('dialog-terms-of-use'):_vm._e(),(_vm.app !== undefined && _vm.app.recruiterTermsVisible)?_c('dialog-recruiter-terms'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }